import {
    DEFAULT_EMPTY_VALUE,
    PROVIDER_SOURCES,
    CREDIT_SUMMARY_NUMBER_FIELDS,
  } from 'src/constants/companyReport';
import { formatDate, formatNumber } from 'src/services/companyReportDetail.service';
import lodash from 'lodash';
import { useEffect } from 'react';

interface Props {
activeIndex: string;
handleOnClick: (index: string) => void;
detailData: any;
}
const CreditSummary = ({ activeIndex, handleOnClick, detailData }: Props) => {
const creditSummary = detailData?.companyProfile?.companyProfile?.creditSummary;
useEffect(() => {
    if (Object.keys(creditSummary ?? {}).length) {
    for (let propertName of CREDIT_SUMMARY_NUMBER_FIELDS) {
        let value = lodash.get(creditSummary, propertName.split('.'));
        if (value && !value?.toString().includes(',')) {
        lodash.set(creditSummary, propertName.split('.'), formatNumber(value));
        }
    }
    }
}, [detailData]);

return (
    <div className={`card accordion ${activeIndex === 'credit-summary' ? 'active' : ''}`}>
    <div className="accordion-heading" onClick={() => handleOnClick('credit-summary')}>
        <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-4 align-items-center">
            <h4 className="mb-0">CREDIT SUMMARY</h4>
        </div>
        <div>
            <img
            className="chevron-icon"
            src={require('src/assets/images/icons/chevron-down.svg').default}
            alt="chevron-down icon"
            />
        </div>
        </div>
    </div>
    <div className="accordion-content">
        {detailData.source === PROVIDER_SOURCES.DNB ? (
        <DnbCreditSummary creditSummary={creditSummary} />
        ) : (
        <OtherCreditSummary creditSummary={creditSummary} />
        )}
    </div>
    </div>
);
};

const DnbCreditSummary = ({ creditSummary }: any) => {
return (
    <table className="accordion-table sm-th-md-td">
    <thead>
        <tr>
        <th>D&B Rating</th>
        <th>Description</th>
        <th>Credit Advice (CUR)</th>
        <th>Failure Score</th>
        <th>Delinquency Score</th>
        <th>Score Date</th>
        </tr>
    </thead>
    <tbody>
        <tr>
        <td className={creditSummary?.standardRating?.rating ? '' : 'text-center'}>
            {creditSummary?.standardRating?.rating ?? DEFAULT_EMPTY_VALUE}
        </td>
        <td
            title={
            creditSummary?.standardRating?.ratingReason?.length
                ? creditSummary?.standardRating?.ratingReason
                    .map((reason: any) => reason?.description ?? '')
                    .join(',')
                : ''
            }
            className={creditSummary?.standardRating?.ratingReason?.length ? '' : 'text-center'}
        >
            {creditSummary?.standardRating?.ratingReason?.length
            ? creditSummary?.standardRating?.ratingReason[0]?.description
            : DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={
            creditSummary?.creditLimitRecommendation?.maximumRecommendedLimit?.value
                ? ''
                : 'text-center'
            }
        >
            {creditSummary?.creditLimitRecommendation?.maximumRecommendedLimit?.value
            ? `${creditSummary.creditLimitRecommendation.maximumRecommendedLimit.value}  (${creditSummary?.creditLimitRecommendation?.maximumRecommendedLimit?.currency})`
            : DEFAULT_EMPTY_VALUE}
        </td>
        <td className={creditSummary?.failureScore?.classScore ? '' : 'text-center'}>
            {creditSummary?.failureScore?.classScore ?? DEFAULT_EMPTY_VALUE}
        </td>
        <td className={creditSummary?.delinquencyScore?.classScore ? '' : 'text-center'}>
            {creditSummary?.delinquencyScore?.classScore ?? DEFAULT_EMPTY_VALUE}
        </td>
        <td className={creditSummary?.standardRating?.scoreDate ? '' : 'text-center'}>
            {formatDate(creditSummary?.standardRating?.scoreDate) ?? DEFAULT_EMPTY_VALUE}
        </td>
        </tr>
    </tbody>
    </table>
);
};

const OtherCreditSummary = ({ creditSummary }: any) => {
return (
    <table className="accordion-table sm-th-md-td">
    <thead>
        <tr>
        <th>Period</th>
        <th>Common Credit Rating</th>
        <th>Common Description</th>
        <th>Credit Limit (CUR)</th>
        <th>Provider Credit Rating</th>
        <th>Provider Description</th>
        <th>Date of change</th>
        </tr>
    </thead>
    <tbody>
        <tr>
        <td>Current</td>
        <td className={creditSummary?.currentCreditRating?.commonValue ? '' : 'text-center'}>
            {creditSummary?.currentCreditRating?.commonValue || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={creditSummary?.currentCreditRating?.commonDescription ? '' : 'text-center'}
        >
            {creditSummary?.currentCreditRating?.commonDescription || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={creditSummary?.currentCreditRating?.creditLimit?.value ? '' : 'text-center'}
        >
            {creditSummary?.currentCreditRating?.creditLimit?.value}
            {creditSummary?.currentCreditRating?.creditLimit?.currency ?? DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={
            creditSummary?.currentCreditRating?.providerValue?.value ? '' : 'text-center'
            }
        >
            {creditSummary?.currentCreditRating?.providerValue?.value || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={creditSummary?.currentCreditRating?.providerDescription ? '' : 'text-center'}
        >
            {creditSummary?.currentCreditRating?.providerDescription || DEFAULT_EMPTY_VALUE}
        </td>
        <td>-</td>
        </tr>
        <tr>
        <td>Previous</td>
        <td className={creditSummary?.previousCreditRating?.commonValue ? '' : 'text-center'}>
            {creditSummary?.previousCreditRating?.commonValue || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={creditSummary?.previousCreditRating?.commonDescription ? '' : 'text-center'}
        >
            {creditSummary?.previousCreditRating?.commonDescription || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={creditSummary?.previousCreditRating?.creditLimit?.value ? '' : 'text-center'}
        >
            {creditSummary?.previousCreditRating?.creditLimit?.value}
            {creditSummary?.previousCreditRating?.creditLimit?.currency ?? DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={
            creditSummary?.previousCreditRating?.providerValue?.value ? '' : 'text-center'
            }
        >
            {creditSummary?.previousCreditRating?.providerValue?.value || DEFAULT_EMPTY_VALUE}
        </td>
        <td
            className={
            creditSummary?.previousCreditRating?.providerDescription ? '' : 'text-center'
            }
        >
            {creditSummary?.previousCreditRating?.providerDescription || DEFAULT_EMPTY_VALUE}
        </td>
        <td className={creditSummary?.latestRatingChangeDate ? '' : 'text-center'}>
            {creditSummary?.latestRatingChangeDate || DEFAULT_EMPTY_VALUE}
        </td>
        </tr>
    </tbody>
    </table>
);
};

export default CreditSummary;
